import {Dialog, DialogActions, DialogContent, DialogTitle, Typography, WithStyles, withStyles} from '@material-ui/core';
import Button from "@components/common/button/Button";
import * as React from 'react';
import { FamilyMemberType } from '@services/family/family.constants';
import * as FamilyActions from '@services/family/family.actions';

import TranslateNew from '@translate/TranslateNew';
import { connect } from 'react-redux';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { Link } from 'react-router-dom';
import {AddUserDialogStyle as styles} from './AddUserDialog.style';

const tn :TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof styles> {
  isOpen: boolean;
  onClose: () => void;
  member?:IFamilyMember;
  addUser: (data: IFamilyMember) => void;
}



class AddUserDialog extends React.Component<IProps> {
  
  constructor(props: IProps) {
    super(props);

    this.state = {
      firstName: "",
      lastName: "",
      yearBorn: 2008,
      firstNameError: false,
      lastNameError: false,
      yearBornError: false,
    };

}

  public render() {

    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.props.onClose}
      >
        <DialogTitle>
          {tn.lang.addUser}
        </DialogTitle>
        <DialogContent style={{display:'flex', flexDirection:'column', gap:'24px'}}>
          <Typography >{tn.lang.addUserName(this.props.member?.firstName || "unkown")}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>{tn.lang.cancel}</Button>
          <Button variant='contained' color='primary' onClick={this.handleSubmit}>
            {tn.lang.add}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  private handleSubmit = () => {
    if (this.props.member !== undefined) {
      const newMember:IFamilyMember = {...this.props.member, role:FamilyMemberType.VIEWER};
      this.props.addUser(newMember);
      this.props.onClose();
    }
  }
}


const mapDispatchToProps = {
  addUser: FamilyActions.addUser,
};
export default connect(undefined, mapDispatchToProps)(withStyles(styles)(AddUserDialog));



// WEBPACK FOOTER //
// ./src/components/extended-family/add-child-dialog/AddUserDialog.tsx